import { atom } from 'recoil';

export const inflightCadencesPage = atom({
  key: 'inflightCadencesPage',
  default: 1,
});
